
<div>
  <label class="label-infra-size"> Infra Size</label>
  <div class="grid grid-cols-2 gap-x-2">
    <div class="flex">
      <Select
        v-model="values[serviceType].resourceSize.cpuUnit"
        :items="cpuUnitOptions"
        label="CPU Unit"
        class="select-v2 flex-1"
        :solo="false"
        @change="(v) => hanldeChange('cpu', v)"
      />
      <Input
        v-model="values[serviceType].resourceSize.cpu"
        label="CPU - Value"
        type="number"
        appendClass="input-text-field-v2 flex-3"
        :rules="[rules.required, validateTotalSize('cpu')]"
        @blur="validate"
        @change="(v) => hanldeValueChange()"
      />
    </div>

    <div class="flex">
      <Select
        v-model="values[serviceType].resourceSize.memoryUnit"
        :items="memoryUnitOptions"
        label="Memory Unit"
        appendClass="select-v2 flex-1"
        :solo="false"
        @change="(v) => hanldeChange('memory', v)"
      />
      <Input
        v-model="values[serviceType].resourceSize.memory"
        label="Memory - Value"
        type="number"
        appendClass="input-text-field-v2 flex-3"
        :rules="[rules.required, validateTotalSize('memory')]"
        @blur="validate"
        @change="(v) => hanldeValueChange()"
      />
    </div>

    <div class="switch-v2-group col-span-2">
      <Sw
        v-model="values[serviceType].gpuEnabled"
        inset
        appendClass="switch-v2"
        :disabled="!gpuAvailable"
        @input="switchGPUCore"
      ></Sw>
      <span class="text-switch">GPU Configuration</span>
    </div>

    <Input
      v-if="values[serviceType].gpuEnabled"
      v-model="values[serviceType].resourceSize.gpu"
      label="Number of GPUs"
      placeholder="Enter Number of GPUs"
      type="number"
      appendClass="input-text-field-v2"
      :rules="[rules.required, validateGPUInput]"
      :min="1"
      clearable
      @input="inputGPU"
    />
  </div>
</div>
